import { render, staticRenderFns } from "./btnM.vue?vue&type=template&id=d7d5ed94&scoped=true&"
import script from "./btnM.vue?vue&type=script&lang=js&"
export * from "./btnM.vue?vue&type=script&lang=js&"
import style0 from "./btnM.vue?vue&type=style&index=0&id=d7d5ed94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d5ed94",
  null
  
)

export default component.exports